import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1822">
      <div className="dark" data-id="element-1823">
        <Hero data-id="element-1824" />
      </div>
      <WhyUs data-id="element-1825" />
      <Services data-id="element-1826" />
      <HowItWorks data-id="element-1827" />
      <FAQ data-id="element-1828" />
      <Reviews data-id="element-1829" />
      <CtaBanner data-id="element-1830" />
    </main>;
}